import styled from "styled-components";

export const SytledCampusStudents = styled.div`
  .grph-top {
    margin-bottom: 35px;
  }
`;
